import { createContext } from 'react';

// null defers the first camera measurement until the frame has measured its overlay.
export const MapTopInsetContext = createContext<number | null>(0);
